import DefaultElementNodeType from '../DefaultElementNodeType';
import {IMP_MIG_GAP} from '../../metamodel/Concept';

export default class GapNodeType extends DefaultElementNodeType {
	static get typeName() {
		return IMP_MIG_GAP;
	}
}
